/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PeopleProfilePatchRequestShareEmail } from './peopleProfilePatchRequestShareEmail';
import type { PeopleProfilePatchRequestPhone } from './peopleProfilePatchRequestPhone';
import type { PeopleProfilePatchRequestWhatsapp } from './peopleProfilePatchRequestWhatsapp';
import type { PeopleProfilePatchRequestSharePhone } from './peopleProfilePatchRequestSharePhone';
import type { PeopleProfilePatchRequestShareWhatsapp } from './peopleProfilePatchRequestShareWhatsapp';
import type { PeopleProfilePatchRequestShowPhotoToConnections } from './peopleProfilePatchRequestShowPhotoToConnections';
import type { PeopleProfilePatchRequestOpenToConnectGss } from './peopleProfilePatchRequestOpenToConnectGss';
import type { PeopleProfilePatchRequestClearProfilePhoto } from './peopleProfilePatchRequestClearProfilePhoto';

/**
 * Partial update for the owner's people profile.
 */
export interface PeopleProfilePatchRequest {
  shareEmail?: PeopleProfilePatchRequestShareEmail;
  phone?: PeopleProfilePatchRequestPhone;
  whatsapp?: PeopleProfilePatchRequestWhatsapp;
  sharePhone?: PeopleProfilePatchRequestSharePhone;
  shareWhatsapp?: PeopleProfilePatchRequestShareWhatsapp;
  showPhotoToConnections?: PeopleProfilePatchRequestShowPhotoToConnections;
  openToConnectGss?: PeopleProfilePatchRequestOpenToConnectGss;
  clearProfilePhoto?: PeopleProfilePatchRequestClearProfilePhoto;
}
